import { connectorsForWallets, getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  magicEdenWallet, metaMaskWallet, roninWallet, walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import type { Chain } from 'viem';
import { bscTestnet, mainnet, sepolia } from 'viem/chains';
import { http } from 'wagmi';
import { bsc, ronin } from 'wagmi/chains';
import { AVAILABLE_CHAINS, roninSaigon } from '../constants/chains';
import { ENVIRONMENTS } from '../constants/environments';

if (!ENVIRONMENTS.REOWN_PROJECT_ID) {
  throw new Error('REOWN_PROJECT_ID is missing');
}

const DEFAULT_REOWN_APP_NAME = 'Pixion Games Connect';

const connectors = connectorsForWallets(
  [{
    groupName: 'Recommended',
    wallets: [
      roninWallet,
      metaMaskWallet,
      magicEdenWallet,
      walletConnectWallet,
    ],
  }],
  {
    appName: ENVIRONMENTS.REOWN_APP_NAME ?? DEFAULT_REOWN_APP_NAME,
    projectId: ENVIRONMENTS.REOWN_PROJECT_ID,
  },
);

export const wagmiConfig = getDefaultConfig({
  connectors,
  appName: ENVIRONMENTS.REOWN_APP_NAME ?? DEFAULT_REOWN_APP_NAME,
  projectId: ENVIRONMENTS.REOWN_PROJECT_ID,
  chains: AVAILABLE_CHAINS as [Chain, ...Chain[]],
  ssr: true,
  transports: {
    [mainnet.id]: http('https://ethereum-rpc.publicnode.com'),
    [sepolia.id]: http('https://ethereum-sepolia-rpc.publicnode.com'),
    [ronin.id]: http('https://api.roninchain.com/rpc'),
    [roninSaigon.id]: http('https://saigon-testnet.roninchain.com/rpc'),
    [bsc.id]: http('https://56.rpc.thirdweb.com'),
    [bscTestnet.id]: http('https://97.rpc.thirdweb.com'),
  },
} as Parameters<typeof getDefaultConfig>[0]);
